import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import VerbParagraph from '../../components/VerbParagraph';
import VerbRadioInput from '../../components/formComponents/inputs/VerbRadioInput';

class EndSessionResponseSubSlide extends Component {
    static propTypes = {
        responseData: PropTypes.object,
        handleClick: PropTypes.func
    };

    render() {
        const { responseData, handleClick } = this.props;
        const didMeet = get(responseData, 'didMeet.value', '');
        const meetingLength = get(responseData, 'meetingLength.value', '');
        const didMeetOptions = [
            { value: 'Yes', label: 'Yes' },
            { value: 'No', label: 'No' }
        ];
        const meetingLengthOptions = [
            { value: '< 30 min', label: 'Less than 30 minutes' },
            { value: '30 - 60 min', label: '30 minutes - 1 hour' },
            { value: '< 2 hrs', label: '1 - 2 hours' },
            { value: '2+ hrs', label: 'More than 2 hours' }
        ];

        return (
            <div className={'end-session-response-slide'}>
                <VerbParagraph
                    messageId={'END_SESSION_DID_YOU_MEET'}
                    defaultMessage={'Did you meet with your partner to complete this section?'}
                />
                <VerbRadioInput
                    value={didMeet}
                    options={didMeetOptions}
                    onChange={(selected) => handleClick('didMeet', selected)}
                />
                {didMeet === 'Yes' ? (
                    <div>
                        <VerbParagraph
                            messageId={'END_SESSION_MEETING_LENGTH'}
                            defaultMessage={'How long was your meeting?'}
                        />
                        <VerbRadioInput
                            value={meetingLength}
                            options={meetingLengthOptions}
                            onChange={(selectedId) => handleClick('meetingLength', selectedId)}
                        />
                    </div>
                ) : null}
            </div>
        );
    }
}

export default EndSessionResponseSubSlide;
